import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import "./card.scss"
export default function Card() {
  const {t} = useTranslation(["cards"]);

  return (
    <div className="cardDiv">
      <div className="scene">
    <div className="card">
      <div className="card_inner">
        <div className="card__face card__face--front words">
          <div className="main title">
            {t("TWords")}
          </div>
        </div>
        <div className="card__face card__face--back">
          <div className="category">
            <div className="logo">
              <img src="https://cdn-icons-png.flaticon.com/512/3627/3627777.png" alt="" />
            </div>
            <h2 className="title">   {t("TWords")}</h2>
          </div>
          <div className="desc">
            <p>
            {t("DWords")}
            </p>
            <span className='listo'> {t("Ready")}</span>
          </div>
          <Link to="/palabras">
          <button>{t("Start")}</button>
          </Link>
        </div>
      </div>
    </div>
    <div className="card">
      <div className="card_inner">
        <div className="card__face card__face--front topics">
        <div className="main title">
            {t("TTopics")}
          </div>
        </div>
        <div className="card__face card__face--back">
        <div className="category">
            <div className="logo">
              <img src="https://cdn-icons-png.flaticon.com/512/4277/4277080.png" alt="" />
            </div>
            <h2 className="title">{t("TTopics")}</h2>
          </div>
          <div className="desc">
            <p>
              {t("DTopics")}                            
            </p>
            <span className='listo'>{t("Ready")}</span>
          </div>
          <Link to="/tematica">
            <button>{t("Start")}</button>
          </Link>
        </div>
      </div>
      
    </div>
    <div className="card">
      <div className="card_inner">
      <div className="card__face card__face--front questions">
      <div className="main title">
          {t("TQuestions")}
      </div>
      </div>
      <div className="card__face card__face--back">
      <div className="category">
          <div className="logo">
            <img src="https://cdn-icons-png.flaticon.com/512/942/942802.png" alt="" />
          </div>
          <h2 className="title"> {t("TQuestions")}</h2>
        </div>
        <div className="desc">
          <p>
          {t("DQuestions")}
          </p>
          <span className='listo'>{t("Ready")}</span>
        </div>
        <Link to="/preguntas">
          <button>{t("Start")}</button>
        </Link>
      </div>
    </div>
      </div>
      
</div>

    </div>
  )
}
